import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { purchaseBuyers, purchaseToast } from "../data/purchases";
import { offer } from "../data/salesCopy";
type Toast = {
  name: string;
  place: string;
  plan: string;
  minutesAgo: number;
};
function randomBetween(min: number, max: number) {
  return Math.floor(min + Math.random() * (max - min));
}
export function PurchaseToast() {
  const [toast, setToast] = useState<Toast | null>(null);
  const lastIndex = useRef(-1);
  useEffect(() => {
    let showTimer: ReturnType<typeof setTimeout>;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      let i = randomBetween(0, purchaseBuyers.length);
      if (i === lastIndex.current) i = (i + 1) % purchaseBuyers.length;
      lastIndex.current = i;
      // Pack Completo appears more often, matching it as the most chosen option
      const plan = Math.random() < 0.7 ? offer.plans[1] : offer.plans[0];
      setToast({
        ...purchaseBuyers[i],
        plan: plan.name,
        minutesAgo: randomBetween(1, 9)
      });
      hideTimer = setTimeout(() => setToast(null), purchaseToast.visibleMs);
      showTimer = setTimeout(show, randomBetween(purchaseToast.minIntervalMs, purchaseToast.maxIntervalMs));
    };
    showTimer = setTimeout(show, purchaseToast.firstDelayMs);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <div className="pointer-events-none fixed bottom-20 left-3 right-3 z-50 flex md:bottom-6 md:left-6 md:right-auto" aria-live="polite" data-id="element-244" data-mp="1fhbs3969vnwr">
      <AnimatePresence data-id="element-245" data-mp="1kfwkwnj735b6">
        {toast && <motion.div key={toast.name + toast.minutesAgo} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full items-center gap-3 rounded-2xl bg-card p-3 pr-2 shadow-[0_10px_30px_rgba(30,42,36,0.18)] ring-1 ring-line md:w-80" data-id="element-246" data-mp="1p7elhahb33vm">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-chalk-soft font-bold text-chalk" aria-hidden="true" data-id="element-247" data-mp="1v13qn21fzdmf">
              {toast.name.charAt(0)}
            </span>
            <div className="min-w-0 flex-1" data-id="element-248" data-mp="24v3ul0kzmctk">
              <p className="truncate text-sm" data-id="element-249" data-mp="1h46po7rm0frt">
                <span className="font-bold" data-id="element-250" data-mp="1h4zzxips1nep">{toast.name}</span> <span className="text-muted" data-id="element-251" data-mp="1c53xhnwqa419">de {toast.place}</span>
              </p>
              <p className="text-xs" data-id="element-252" data-mp="1q4d2rsjebdqg">
                {purchaseToast.bought} <span className="font-bold text-chalk" data-id="element-253" data-mp="1q1h2hxk2scyu">{toast.plan}</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] text-muted" data-id="element-254" data-mp="1l6v2eqjg26u2">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-chalk" aria-hidden="true" data-id="element-255" data-mp="31h5p2ntf39z4" />
                {purchaseToast.label} · hace {toast.minutesAgo} min
              </p>
            </div>
            <button type="button" onClick={() => setToast(null)} aria-label="Cerrar notificación" className="self-start rounded-full p-1 text-muted transition-colors duration-150 ease-out hover:bg-paper" data-id="element-256" data-mp="34zcxnvscyok3">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-257" data-mp="3011q5rpjcq51" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}